import {gsap} from "gsap";
import $ from 'jquery';
global.$ = global.jQuery = $;

var _debug = false;
var __c__ = function(data){
  if(_debug){
    console.dir(data);
  }
};

// ScrollAnimatiopn
window.AnimationStart = function($container){
  var _$wait = $($container).find(".wait");
  _$wait.each(function(){
    var __$this = $(this);
    var __delay = __$this.data("delay");
    var __timeout = setTimeout(function(){
      __$this
        .removeClass("wait")
        .addClass("animation");
      clearTimeout(__timeout);
    }, __delay)
  });
};

window.ResetAnimate = function($container){
  // __c__("ResetAnimate");
  var _$animate = $container.find(".animation");
  var _$animating = $container.find(".animated");
  _$animate.each(function(){
    var __$this = $(this);
    __$this
      .addClass("wait")
      .removeClass("animation");
  });
  _$animating.each(function(){
    var __$this = $(this);
    __$this
      .addClass("waiting")
      .removeClass("animated");
  });
};

window.setAnimation = function(){
  let targets = document.querySelectorAll(".waiting");
  let targetsLen = targets.length;
  let scrollY = window.scrollY;
  let windowHeight = window.innerHeight;
  let timing = windowHeight - (windowHeight / 5);

  for(let i = 0; i < targetsLen; i++){
    let target = targets[i];
    let offsetTop = scrollY + target.getBoundingClientRect().top;

    if(scrollY + timing >= offsetTop && scrollY <= offsetTop){
      let delay = target.dataset.delay | 0;
      if(delay === void 0){
        delay = 0;
      }
      gsap.to( target, {
        duration: .1,
        delay : delay / 1000,
        onComplete: function(){
          target.classList.add("animated");
          target.classList.remove("waiting");
        },
      });
    }
  }
  if(targetsLen === 0){
    window.removeEventListener('scroll', AnimationScroller);
  }
};

global._isSP = undefined;

if(window.outerWidth < 829){
  _isSP = true;
}else{
  _isSP = false;
}

// RESULT PAGE
var resultPage = document.querySelector(".result_page");
if(resultPage !== null) {
  __c__("RESULT PAGE");

  global.storeData = [];
  var currentStoresData = [];

  var max = 10;
  var storeBlocks = [];

  var search = location.search;
  var searchQuery = null;
  searchQuery = search.replace(/.?/, "").split("&");
  __c__(searchQuery);

  var queryObj = {};
  for(var s = 0; s < searchQuery.length; s++){
    var _query = searchQuery[s].split("=");
    queryObj[_query[0]] = decodeURI(_query[1]).split(",");
  }
  var page;
  if(queryObj["page"]){
    page = Number(queryObj["page"] | 0);
  }else{
    page = 1;
  }

  var debug;
  if(queryObj["debug"]){
    debug = Number(queryObj["debug"] | 0);
  }else{
    debug = 0;
  }

  __c__(queryObj);

  var resultContentWrap = document.getElementById("result_content");
  resultContentWrap.style.minHeight = "inherit";

  // SET LOCATION
  // 範囲は10km (10000m )
  var range = 10000;
  __c__("範囲は" + range + "m");
  var SetCurrentLocationStores = function(points){
    __c__("SetCurrentLocationStores");
    __c__(points);
    __c__(storeData);

    var _lat = Number(points[0]);
    var _lon = Number(points[1]);

    var _latlot = new ZDC.LatLon(_lat, _lon)
    __c__(_latlot);
    currentStoresData = [];

    for(var i = 0; i < storeData.length; i++){
      var _storeLat = storeData[i]["緯度"];
      var _storeLon = storeData[i]["経度"];

      // 2点間の距離（m）
      var _dist = ZDC.getLatLonToLatLonDistance(_latlot, new ZDC.LatLon(_storeLat, _storeLon));

      if(_dist < range){
        __c__(_dist);
        storeData[i]["distance"] = _dist;
        currentStoresData.push(storeData[i])
      }
    }

    currentStoresData.sort((a,b)=>{
      if(a.distance < b.distance) return -1;
      else if(a.name > b.name) return 1;
      return 0;
    })

    __c__(currentStoresData);
    SetStores(currentStoresData);
  };

  // GET STORE HTML
  var StoreHTML = function(data){
    if(data === void 0 | data === null || data.length === 0 || data["No"] === "") {
      return false;
    }

    var _store = document.createElement("div");
    _store.classList.add("result-store");

    var _name = document.createElement("p");
    _name.classList.add("result-store--name");
    _name.innerText = data["店舗名"];
    _store.appendChild(_name);

    var _address = document.createElement("p");
    _address.classList.add("result-store--address");
    _address.innerHTML = "住所：" + data["住所"].replaceAll("　","<br>");
    _store.appendChild(_address);

    var _station = document.createElement("p");
    _station.classList.add("result-store--station");
    _station.innerText = "最寄駅：" + data["最寄駅"];
    _store.appendChild(_station);

    var _categoryData = data["カテゴリー"];
    var _category = document.createElement("div");
    _category.classList.add("result-store--category");
    var _categoryP = document.createElement("p");
    _categoryP.innerText = "特典カテゴリー："
    _category.appendChild(_categoryP);
    var _categoryTags = document.createElement("div");
    _categoryTags.classList.add("tags");
    for(var c = 0; c < _categoryData.length; c++){
      var _categoryTag = document.createElement("div");
      _categoryTag.innerHTML = _categoryData[c];
      _categoryTags.appendChild(_categoryTag);
    }
    _category.appendChild(_categoryTags);
    _store.appendChild(_category);

    var _way = document.createElement("div");
    _way.classList.add("result-store--way");
    var _wayP = document.createElement("p");
    _wayP.innerText = "特典のご利用方法："
    _way.appendChild(_wayP);
    var _ways = document.createElement("div");
    _ways.classList.add("ways");
    if(data["ICOCA"] === "1"){
      var _icoca = document.createElement("div");
      _icoca.innerHTML = '<p>ICOCA定期券での決済</p><img class="icoca" src="../assets/img/search/icon_icoca.png" alt="" width="98" height="78">';
      _ways.appendChild(_icoca);
    }
    if(data["WESTERバーコード提示"] === "1"){
      var _waster = document.createElement("div");
      _waster.innerHTML = '<p>WESTERアプリまたは<br>WESPOアプリのバーコード提示</p><img class="wester" src="../assets/img/search/icon_wester.png" alt="" width="98" height="78">';
      _ways.appendChild(_waster);
    }
    _way.appendChild(_ways);
    _store.appendChild(_way);

    if(data["備考"] !== "0" && data["備考"] !== ""){
      var _remark = document.createElement("p");
      _remark.classList.add("result-store--remarks");
      _remark.innerText = data["備考"];
      _store.appendChild(_remark);
    }

    var _button = document.createElement("div");
    _button.classList.add("btn","btn--blue","result-store--btn");
    var _link = document.createElement("a");
    _link.setAttribute("href", "https://www.google.com/maps?q=" + data["店舗名"] + " " + data["住所"]);
    _link.setAttribute("target", "_blank");
    _link.innerHTML = "<span>地図を見る</span>";


    if(
      data["No"] !== "102"
      && data["No"] !== "476"
      && data["No"] !== "477"
    ){
      _button.appendChild(_link);
      _store.appendChild(_button);
    }

    return _store;

  };

  // SET STORES
  var SetStores = function(stores){
    __c__("SetStores");
    __c__(stores);

    if(stores.length !== 0){

      var _blockLen = ((stores.length - 1) / max) | 0;
      storeBlocks = [];
      for(var a = 0; a <= _blockLen; a++){
        storeBlocks.push(a);
      }

      SetPagination();

      for(var i = 0; i < stores.length; i++){
        var _store = StoreHTML(stores[i]);
        if(debug){
          if(_store !== false){
            resultContentWrap.appendChild(_store);
          }
        }else{
          if(((page - 1) * max) <= i && i < (page * max)){
            if(_store !== false){
              resultContentWrap.appendChild(_store);
            }
          }
        }
      }
      $(".no-exist").css({display: "none"});
    }else{
      $(".is-exist").css({display: "none"});
      __c__("no hit");
    }

  };

  // PAGINATION
  var SetPagination = function(){
    __c__("SetPagination");

    if(debug) return;

    if(page === void 0 || page === null){
      page = 1;
    }

    __c__(page);

    var _$pagination = $("#pagination");
    var _$prevBtn = _$pagination.find(".pagination--prev a");
    var _$nextBtn = _$pagination.find(".pagination--next a");
    var _$lists = _$pagination.find(".pagination-nums").empty();

    var _hrefPaths = search.replace(/.?/, "").split("&");
    __c__(_hrefPaths);

    var _hrefArr = [];
    for(var p = 0; p < _hrefPaths.length; p++){
      if(_hrefPaths[p].indexOf("page=") < 0){
        _hrefArr.push( _hrefPaths[p]);
      }
    }

    __c__(_hrefArr);

    var _href = "?" + "";
    if(_hrefArr.length > 0 && _hrefArr[0] !== ""){
      _href += _hrefArr.join("&");
      _href += "&page=";
    }else{
      _href += "page=";
    }

    __c__(_href);

    var _AddList = function(num){
      var __num = num;
      var __$a = $("<a></a>").text(__num).attr("href", _href + __num.toString());
      var __$list = $("<div class='pagination--list'></div>").append(__$a);
      if((i + 1) === page){
        __$list.addClass('current');
      }
      _$lists.append(__$list);
    }
    var _AddDots = function(){
      var __$list = $("<div class='pagination--list'>・・・</div>");
      _$lists.append(__$list);
    }

    for(var i = 0; i < storeBlocks.length; i++){
      var __num = i + 1;
      var __last = storeBlocks.length - 1;

      if(__last < 10){
        _AddList(__num);
      }else{
        if(i === 0 || i === __last){
          _AddList(__num);
        }else{
          if(page <= 4 && __num <= 6){
            _AddList(__num);
            if(page <= 3 && __num === 6){
              _AddDots();
            }
          }else if(page >= __last - 1 && __num >= __last - 4){
            if(__num === __last - 4){
              _AddDots();
            }
            _AddList(__num);
          }else{
            if(page - 2 <= __num && page + 2 >= __num){
              _AddList(__num);
            }else if(page - 3 === __num){
              if(page - 4 === 1){
                _AddList(__num);
              }else{
                _AddDots();
              }
            }else if(page + 3 === __num){
              if(page + 3 === __last){
                _AddList(__num);
              }else{
                _AddDots();
              }
            }
          }
        }
      }
      if(__num === page){
        _$prevBtn.attr("href", _href + (__num - 1).toString());
        _$nextBtn.attr("href", _href + (__num + 1).toString());
      }
    }

    if(page <= 1){
      _$prevBtn.remove();
    }
    if(page === storeBlocks.length){
      _$nextBtn.remove();
    }
  };

  // SET HEAD TAGS
  var SetHeadTags = function(tags){
    __c__("SetHeadTags");
    __c__(tags);
    var mVvTags = document.querySelector(".mv-tags");

    if(Array.isArray(tags)){
      for(var t = 0; t < tags.length; t++){
        var _div = document.createElement("div");
        _div.innerText = tags[t];
        mVvTags.appendChild(_div);
      }
    }else if(typeof tags === "string"){
      var _div = document.createElement("div");
      _div.innerText = tags;
      mVvTags.appendChild(_div);
    }
  };

  // QUERY
  var CheckQuery = function(){
    __c__("CheckQuery");
    resultContentWrap.innerHTML = "";
    if(search === ""){
      SetStores(storeData);
      SetHeadTags("全店舗");
    }else {
      if(queryObj["point"]){
        // point（座標）があった場合
        SetCurrentLocationStores(queryObj["point"]);
        SetHeadTags("近くの店舗を探す");
      }else if(queryObj["pref"] || queryObj["station"] || queryObj["category"]){
        if(searchQuery[0] !== ""){
          currentStoresData = [];
          var _tags = [];
          for(var key in queryObj){
            var _q = queryObj[key];
            if(key === "pref"){
              for(var pr = 0; pr < _q.length; pr++){
                _tags.push(_q[pr]);
              }
            }else if(key === "station"){
              for(var ss = 0; ss < _q.length; ss++){
                _tags.push(_q[ss]);
              }
            }else if(key === "category"){
              for(var ca = 0; ca < _q.length; ca++){
                _tags.push(_q[ca]);
              }
            }
          }

          for(var s = 0; s < storeData.length; s++){
            var _store = storeData[s];
            var _isSearchPref = false;
            var _isSearchStation = false;
            var _isSearchCategory = false;
            var _isPref = false;
            var _isStation = false;
            var _isCategory = false;

            var _pref = _store["都道府県"];
            var _station = _store["主要駅"];
            var _category = _store["カテゴリー"];

            for(var key in queryObj){
              if(key !== "page"){
                var _q = queryObj[key];
                if(key === "pref"){
                  _isSearchPref = true;
                  for(var pr = 0; pr < _q.length; pr++){
                    if(_q[pr] === _pref){
                      _isPref = true;
                    }
                  }
                }else if(key === "station"){
                  _isSearchStation = true;
                  for(var ss = 0; ss < _q.length; ss++){
                    if(_q[ss] === _station){
                      _isStation = true;
                    }
                  }
                }else if(key === "category"){
                  _isSearchCategory = true;
                  for(var ca = 0; ca < _q.length; ca++){
                    for(var c = 0; c < _category.length; c++){
                      if(_q[ca] === _category[c]){
                        _isCategory = true;
                      }
                    }
                  }
                }
              }
            }

            if(_isSearchPref || _isSearchStation){
              if(_isPref || _isStation) {
                if(_isSearchCategory){
                  if(_isCategory){
                    __c__("都道府県 OR 最寄り駅 ＋ Category");
                    currentStoresData.push(_store);
                  }
                }else{
                  currentStoresData.push(_store);
                }
              }
            }else{
              if(_isSearchCategory){
                if(_isCategory){
                  __c__("Categoryのみ");
                  currentStoresData.push(_store);
                }
              }
            }
          }

          SetStores(currentStoresData);
          SetHeadTags(_tags);
        }
      }else{
        SetStores(storeData);
        SetHeadTags("全店舗");
      }
    }
  };

  var csvSplit = function(line, debug) {
    //var _debug = debug ? true : false;
    var c = "";
    var s = "";
    var data = [];
    var singleQuoteFlg = false;

    for (var i = 0; i < line.length; i++) {
      c = line.charAt(i);
      if (c === "," && !singleQuoteFlg) {
        data.push(s.toString());
        s = "";
      } else if (c === "," && singleQuoteFlg) {
        s = s + c;
      } else if (c === '"') {
        singleQuoteFlg = !singleQuoteFlg;
      } else {
        s = s + c;
      }
    }
    data.push(s.toString());
    return data;
  }

  var parseCSV = function(data){
    var lineArr = data.split("\r\n");
    var _header = lineArr[0].split(",");
    for(var i = 0; i < lineArr.length; i++){
      if(i !== 0){
        var store = csvSplit(lineArr[i]);
        var storeContent = {};
        storeContent["カテゴリー"] = [];
        for(var l = 0; l < store.length; l++){
          if(l > 3 && l < 11){
            if(store[l] === "1"){
              storeContent["カテゴリー"].push(_header[l]);
            }
          }else if(l === 18 || l === 19){
            storeContent[_header[l]] = Number(store[l]);
          }else{
            storeContent[_header[l]] = store[l];
          }
        }
        global.storeData.push(storeContent);
      }else{
      }
    }
  };


  // CSV 読み込み
  fetch('../assets/data/icocaplus.csv')
    .then(response => response.text())
    .then(data => {
      parseCSV(data);
      CheckQuery();
    });

}

var _body = document.getElementsByTagName("body")[0];

var Init = function(){
  AnimationStart(".kv");
  _body.classList.remove("is-hidden");

  var $window = $(window);
  var $body = $("body").addClass("loaded");
  var $header = $("header");

  $body.stop().delay(0).animate({opacity: 1}, 500);
  $header.stop().delay(0).animate({opacity: 1}, 300);


  window.AnimationScroller = function(){
    setAnimation();

    if($body.css("opacity") !== "1"){
      $body.stop().animate({opacity: 1}, 100);
    }
  };

  // INDEX PAGE
  var indexPage = document.querySelector(".index_page");
  if(indexPage !== null) {
    __c__("INDEX PAGE");
    var theme = document.querySelectorAll(".information-content");
    var themeHead = document.querySelectorAll(".accordion--btn");
    var themeAccordion = function(event){
      var _this = event.currentTarget;
      var _parent = _this.parentNode;

      theme.forEach(function(elm){
        var _content = elm.querySelector(".accordion");
        var _delay = .01;
        var completeFunc = null;
        if(_parent === elm) {
          if(elm.classList.value.indexOf("open") > -1){
            elm.classList.remove("open");
          }else{
            elm.classList.add("open");
          }

          gsap.to(_content, {
            delay: _delay,
            height: (elm.classList.value.indexOf("open") > -1) ? "auto" : 0,
            duration: 0.25,
            ease: "power2.inOut",
            onComplete : completeFunc
          });
        }else{
          //elm.classList.remove("open");
          //_content.style.height = "0";
        }


      });

      return false;
    };
    themeHead.forEach(function(elm){
      elm.addEventListener("click", themeAccordion);
    });
  }

  // SEARCH PAGE
  var searchPage = document.querySelector(".search_page");
  if(searchPage !== null) {
    __c__("SEARCH PAGE");

    // ACCORDION
    var theme = document.querySelectorAll(".search-box");
    var themeHead = document.querySelectorAll(".accordion--btn");
    var themeAccordion = function(event){
      var _this = event.currentTarget;
      var _parent = _this.parentNode;

      theme.forEach(function(elm){
        var _content = elm.querySelector(".accordion");
        var _delay = .01;
        if(_parent === elm) {
          if(elm.classList.value.indexOf("open") > -1){
            elm.classList.remove("open");
          }else{
            elm.classList.add("open");
          }
          gsap.to(_content, {
            delay: _delay,
            height: (elm.classList.value.indexOf("open") > -1) ? "auto" : 0,
            duration: 0.25,
            ease: "power2.inOut"
          });
        }
      });

      return false;
    };
    themeHead.forEach(function(elm){
      elm.addEventListener("click", themeAccordion);
    });

    // GEOLOCATION
    var locationBtn = document.querySelector(".location--btn");
    var GetCurreuntPosition = function(){
      navigator.geolocation.getCurrentPosition(
        function(position){
          // success
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          location.href = "result.html?point=" + latitude + "," + longitude;
        },
        function(){
        alert("現在位置の取得には端末ユーザーの許可が必要です。");
      }
      );

      return false;
    };
    locationBtn.addEventListener("click", GetCurreuntPosition);

    // SUBMIT VALUES
    var submitBtn = document.querySelector(".search--submit");
    var checkboxes = {
      pref : [],
      station : [],
      category : [],
    };
    var checkValues = {
      pref : [],
      station : [],
      category : [],
    };
    var GetCheck = function(){
      var _checkboxes = document.getElementsByTagName("input");
      for(var c = 0; c < _checkboxes.length; c++) {
        var _check = _checkboxes[c];
        if(_check.getAttribute("type") === "checkbox"){
          switch(_check.getAttribute("name")){
            case "pref":
              checkboxes["pref"].push(_check);
              break;
            case "station":
              checkboxes["station"].push(_check);
              break;
            case "category":
              checkboxes["category"].push(_check);
              break;
            default:
              break;
          }
        }
      }
    };
    GetCheck();

    var GetCheckValues = function(){
      checkValues = {
        pref : [],
        station : [],
        category : [],
      };

      for(var a in checkboxes){
        for(var c = 0; c < checkboxes[a].length; c++) {
          var _check = checkboxes[a][c];
          if(_check.checked){
            checkValues[a].push(_check.getAttribute("value"));
          }
        }
      }
    };
    var ClearValues = function(){
      for(var a in checkboxes){
        for(var c = 0; c < checkboxes[a].length; c++) {
          var _check = checkboxes[a][c];
          _check.checked = false;
        }
      }
      return false;
    };
    var SendCheckValues = function(){
      GetCheckValues();

      var _sendArr = [];

      for(var a in checkValues){
        var _sendValue = a + "=";
        var _arr = [];
        if(checkValues[a].length > 0){
          for(var c = 0; c < checkValues[a].length; c++) {
            var _check = checkValues[a][c];
            _arr.push(_check);
          }
          _sendValue += _arr.join(",");
          _sendArr.push(_sendValue);
        }
      }

      if(_sendArr.length > 0) {
        location.href = "result.html?" + _sendArr.join("&");
      }else{
        location.href = "result.html";
      }
    };


    submitBtn.addEventListener("click", SendCheckValues);

    // ClearValue
    var clearBtn = document.querySelector(".search--clear");
    clearBtn.addEventListener("click", ClearValues);
  }


  // RESULT PAGE
  if(resultPage !== null) {
    __c__("RESULT PAGE");
  }


  $window.on("scroll", AnimationScroller);
  $(".pagetop").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 500);
  });

  $(".anchor").on("click", function(){
    var _$this = $(this);
    var _$target = $(_$this.attr("href"));
    $("html, body").stop().animate({scrollTop: _$target.offset().top - $header.outerHeight()}, 500);
    return false;
  });

  var Resize = function(){
    if($window.width() <= 828){
      _isSP = true;
    }else{
      _isSP = false;
    }
  };
  $window.on("resize", Resize);
  Resize();

};

window.addEventListener("load", Init);